import React, {Component} from 'react';
import AREntryTile from './arEntryTile';


export default class AREntryTiles extends Component {
  render() {
    return(
      <div className="tile is-ancestor">
        {this.props.entries.map(
          (entry, index) => <div
            className="tile is-parent"
            key={`GridEntryParent_Child_${index}`}
          >
            {<AREntryTile
                data={entry}
            />}
          </div>
        )}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/arEntryTiles.js